<template>
<div>
  <div class="modal fade" data-backdrop="static" id="modal-copy-booking">
        <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title">{{$t('apartmentbookings.confirm_copy_booking')}}</h1>
              </div>
              <div class="modal-body">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <b-form-group
                            label-size="sm"
                            label-for="input-sm"
                            :label="$t('apartment.apartment_code')"
                        >
                            <div class="form-group">
                                <leaseback-select-option-apartment-custom
                                    :data="apartment_rooms"
                                    @clickOnItem="onChangeApartmentRoom"
                                />
                            </div>
                        </b-form-group>
                    </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  @click="onSave()"
                  :class="'btn btn-primary btn-sm pull-right'"
                >{{$t('common.confirm')}}</button>
                <button
                  type="button"
                  class='btn btn-warning btn-sm pull-left'
                  @click="closeModal"
                >{{$t('common.back')}}</button>
              </div>
            </div>
        </div>
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from 'moment'
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from '@/lib/utils'
import BookingStatusEnum from "@/enum/bookingStatusEnum";
import LeaseBackSelectOptionApartmentCustom from '@/components/SelectOptionApartmentCustom'

export default {
  name: 'lte-modal-apartment-available-leaseback',
  data() {
    return {
        apartment_rooms: [],
        checkin_datetime: null,
        checkout_datetime: null,
        bookingId: null,
        apartmentId: null
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_AVAILABLE_APARTMENT_DATA"
    ])
  },
  methods: {
    onChangeApartmentRoom: function(apartment) {
        this.apartmentId = apartment.value
    },
    showModalApartmentAvailableLeaseback(bookingId, numberOfRoom, checkIn, checkOut) {
        this.bookingId = bookingId
        this.checkin_datetime = checkIn
        this.checkout_datetime = checkOut
        this.getAvailableApartmentList(numberOfRoom, checkIn, checkOut)
        $("#modal-copy-booking").modal("show");
    },
    closeModal: function() {
        this.apartmentId = null
        $("#modal-copy-booking").modal("hide");
    },
    onSave() {
        if (utils.isNull(this.apartmentId)) {
            this.ON_SHOW_TOAST({
                message: "Xin Vui Lòng Chọn 1 Căn Hộ",
                styleType: "danger"
            })
        } else {
            // let current_date = moment().format('YYYY-MM-DD')
            // let checkin_datetime = moment(this.checkin_datetime, 'DD/MM/YYYY').format('YYYY-MM-DD')
            // if (current_date > checkin_datetime) {
            //     this.checkin_datetime = moment(current_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            //     this.checkout_datetime = moment(current_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            // }
            $("#modal-copy-booking").modal("hide");
            this.$router.push({
                name: "LeaseBackApartmentBooking",
                params: {
                    id: this.bookingId
                },
                query: {
                    checkin_datetime: this.checkin_datetime,
                    checkout_datetime: this.checkout_datetime,
                    is_copy_booking: true,
                    apartment_id: this.apartmentId
                }
            });
        }
    },
    getAvailableApartmentList: async function(numberOfRoom, checkIn, checkOut) {
        let current_date = moment().format('YYYY-MM-DD')
        let checkin_datetime = utils.formatSqlDate(checkIn, 'DD/MM/YYYY', 'YYYY-MM-DD')
        if (current_date > checkin_datetime) {
            checkIn = utils.formatSqlDate(current_date, 'YYYY-MM-DD', 'DD/MM/YYYY')
            checkOut = utils.formatSqlDate(current_date, 'YYYY-MM-DD', 'DD/MM/YYYY')
        }
        this.checkin_datetime = checkIn
        this.checkout_datetime = checkOut
      const filter = {
        params: {
          page: 1,
          apt_type: 2,
          apartment_code: "",
          from_size: "",
          to_size: "",
          owner_resident: "",
          status: [],
          checkin_datetime: checkIn ? checkIn : null,
          checkout_datetime: checkOut ? checkOut : null,
          absc: []
        }
      };
      this.apartment_rooms = [
        {
          value: null,
          text: "Đang Tìm Căn Hộ Trống...",
          disabled: true
        }
      ];
      await this.GET_AVAILABLE_APARTMENT_LIST(filter).then(
        function(res) {
          let result = res.data;
          let apartment_rooms = [
          ];
          result.forEach(apartment => {
            if (numberOfRoom == apartment.bedroom_count) {
                if (apartment.booking.booking_status != BookingStatusEnum.CONFIRMED && apartment.booking.booking_status != BookingStatusEnum.ONBOARD) {
                    let item = {
                        value: apartment.id,
                        text: apartment.apartment_code,
                        bedroom_count: apartment.bedroom_count,
                        size: apartment.size
                    };
                    apartment_rooms.push(item);
                }
            }
          });
          this.apartment_rooms = apartment_rooms;
        }.bind(this)
      ).catch(
          function(error) {
                this.apartment_rooms = [
                    {
                        value: null,
                        text: "Có Lỗi Xảy Ra, Vui Lòng Thử Lại !",
                        disabled: true
                    }
                ];
          }.bind(this)
      );
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "GET_AVAILABLE_APARTMENT_LIST"
    ])
  },
  mounted() {
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "leaseback-select-option-apartment-custom": LeaseBackSelectOptionApartmentCustom
  },
}
</script>
<style lang="scss" scoped>
    .mg-left {
        margin-left: 5px;
    }
    .hide-scroll-bar::-webkit-scrollbar {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/LTEModalApartmentAvailableLeaseback.vue